












import { Component, Vue } from 'vue-property-decorator'
import { buildLogoutUrl, clearSession, getAuthority, getIdToken, getPostLogoutRedirectUri } from '@/utils/keycloakLogout'

@Component
export default class ViewSair extends Vue {
  // Rota pública de logout, feita para ser acessada por link direto (fora do app).
  // A mecânica (ler o token do storage, limpar a sessão local, montar a URL do
  // Keycloak) vive em utils/keycloakLogout — autossuficiente por decisão: não
  // depende do Auth do @finx/web-repository nem da ordem de inicialização do App.
  mounted() {
    this.sair()
  }

  sair(): void {
    const idToken = getIdToken()
    clearSession()

    if (!getAuthority()) {
      window.location.replace(getPostLogoutRedirectUri())
      return
    }

    window.location.replace(buildLogoutUrl(idToken))
  }
}
